// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { ProductDetailResponse } from "../../types/ProductDetailResponse";

import { createSlice } from "@reduxjs/toolkit";
import { bookingSliceBody } from "./bookingBody";

// export interface BookingState {
//   productData: ProductDetailResponse | undefined;
//   // selectedVariantkkk?: Variant | null;
//   status?: string;
//   bookingFormInfo?: BookingInfo | undefined;
//   bookingAttributes: {
//     dto: ProductAttributeDTO;
//     value: string;
//   }[];
// }

// export interface ProductBaseInfo {
//   thumbnail?: string;
//   productId: number;
//   name: string;
//   productType: string;
//   status?: string;
//   selectDate?: string;
// }

// // const initialState: BookingState = {
// //   productInfo: undefined,
// //   selectedVariant: undefined,
// //   bookingFormInfo: undefined
// // };

// const bookingSlice = createSlice({
//   name: "booking",
//   initialState: {
//     productData: undefined,
//     // selectedVariantkkk: undefined,a
//     bookingFormInfo: undefined,
//   } as BookingState,
//   reducers: {
//     collectProductAttribute: (
//       state,
//       action: PayloadAction<{
//         dto: ProductAttributeDTO;
//         value: string;
//       }>
//     ) => {
//       const { dto, value } = action.payload;
//       const index = state.bookingAttributes.findIndex((v) => v.dto.id === dto.id);
//       if (index !== -1) {
//         state.bookingAttributes[index].value = value;
//       } else {
//         state.bookingAttributes.push({ dto, value });
//       }
//     },
//     // clearBooking: () => ({
//     //   bookingAttributes: [],
//     //   productInfo: undefined,
//     //   selectedVariant: undefined,
//     //   bookingFormInfo: undefined,
//     // }),
//     updateBookingInfoXXXXX: (state, action) => {
//       const { fieldName, value } = action.payload;

//       state.bookingFormInfo = {
//         ...state.bookingFormInfo,
//         [fieldName]: value,
//       };
//     },
//     updateChildBookingInfo: (
//       state,
//       action: PayloadAction<{
//         fieldName: string;
//         value: any;
//         productId: number;
//       }>
//     ) => {
//       const { fieldName, value, productId } = action.payload;
//       if (state.bookingFormInfo && state.bookingFormInfo.products) {
//         const productIndex = state.bookingFormInfo.products.findIndex(
//           (product) => product?.productId === productId
//         );
//         if (productIndex !== -1) {
//           state.bookingFormInfo.products[productIndex] = {
//             ...state.bookingFormInfo.products[productIndex],
//             [fieldName]: value,
//           };
//         }
//       }
//     },
//     updateBookingRequest: (
//       state,
//       action: PayloadAction<Partial<BookingState>>
//     ) => {
//       if (!action.payload) {
//         return; // Or handle this case more explicitly if needed
//       }
//       const { productData, bookingFormInfo } = action.payload;
//       state.productData =
//         productData ?? (productData === null ? undefined : state.productData);
//       state.bookingFormInfo =
//         bookingFormInfo ??
//         (bookingFormInfo === null ? undefined : state.bookingFormInfo);
//     },
//     // setBookingRequest: (
//     //   state,
//     //   action: PayloadAction<Partial<BookingState>>
//     // ) => {
//     //   state.productInfo = action.payload.productInfo;
//     //   // state.selectedVariantkkk = action.payload.selectedVariantaxxxxxxxxxxxxxx;
//     //   state.bookingFormInfo = action.payload.bookingFormInfo;
//     // },
//     updateQuantity: (
//       state,
//       action: PayloadAction<{
//         qtyAdult?: number;
//         qtyChild?: number;
//         qtyRoom?: number;
//       }>
//     ) => {
//       if (state.bookingFormInfo) {
//         state.bookingFormInfo.qtyAdult =
//           action.payload.qtyAdult ?? state.bookingFormInfo.qtyAdult;
//         state.bookingFormInfo.qtyChild =
//           action.payload.qtyChild ?? state.bookingFormInfo.qtyChild;
//         state.bookingFormInfo.qtyRoom =
//           action.payload.qtyRoom ?? state.bookingFormInfo.qtyRoom;
//       }
//     },
//   },
// });

// export const {
//   updateBookingRequest,
//   updateQuantity,
//   // setBookingRequest,
//   updateBookingInfoXXXXX,
//   collectProductAttribute,
//   updateChildBookingInfo,
//   // clearBooking,
// } = bookingSlice.actions;
// export default bookingSlice.reducer;

const bookingSlice = createSlice({
  name: "booking",
  ...bookingSliceBody,
});

export default bookingSlice.reducer;
export const bookingActions = bookingSlice.actions;
export const {
  bookingPick,
  bookingPickLs,
  replaceBookingAttributes,
  captureProductData,
  resetBooking,
  selectMonth,
} = bookingActions;
